import Cookies from "js-cookie";

function handlebarsMessage(messageText, cookieName, survey) {
    const delta = 200;

    function renderMessage() {
        $.get("/partials/messages/footer-message").done(data => {
            const message = $(
                Handlebars.compile(data)({
                    text: messageText
                })
            );
            message.prependTo("body");
            setTimeout(() => {
                if (message) {
                    if (survey) {
                        message.addClass('cookies-callout-wrapper-survey')
                    }
                    message.addClass("is-visible");
                }
            }, 100);
            message.on("click", ".close", () => {
                message.remove();
                Cookies.set(cookieName, "set", {expires: new Date(3000, 1, 1)});
            });
            message.keypress((e) => {
                const key = e.which;
                if(key === 13) {
                    $('.close').click();
                    return false;
                }
            })
        });
    }

    renderMessage();

    window.addEventListener("resize", () => {
        const banner = document.querySelector(".cookies-callout-wrapper");
        if (banner) {
            document.querySelector("body").removeChild(banner);
            setTimeout(renderMessage, delta);
        }
    });
}

const startDate = new Date(2022, 0, 10, 9,30, 0);
const endDate = new Date(2022, 1, 7, 23,59,0);
const currentDate = new Date().getTime();
const surveyCookie= "survey2022-callout";

if (!Cookies.get(surveyCookie) && Cookies.get("cookie-callout") && startDate <= currentDate && currentDate <= endDate) {
    handlebarsMessage(
        '<a href="https://www.surveymonkey.co.uk/r/T2PCFW8" target="_blank" class="close">Complete our survey</a> and have the opportunity to enter our prize draw to win a £50 Amazon voucher.',
        surveyCookie,
        "survey"
    );
}
